export const stateName = 'notifications' as const
